import "babel-polyfill";
import "./libs/jquery.pagepiling";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder, fwa} from "./libs/binder";
import {constants} from "./modules/module";
import {headerActions} from "./modules/headerActions";
import {customSelect} from "./modules/customSelect";
import {fullHeightPage} from "./modules/fullHeightPage";
import {animationOnScroll} from "./modules/animationOnScroll";
import {heroAnimationSlider} from "./modules/heroAnimationSlider";
import {toTop} from './modules/to-top';
import {sharedValuesSlider} from './modules/sharedValuesSlider';
import {trustedByCompaniesSlider} from './modules/trustedByCompaniesSlider';
import {recognitionSectionSlider} from "./modules/recognitionSectionSlider";
import {customPhotosGallery} from "./modules/customPhotosGallery";
import {parallax} from "./modules/parallax";
import {heroVideoAnimation} from "./modules/heroVideoAnimation";
import {firstSectionScrollBottom} from "./modules/firstSectionScrollBottom";
import {popups} from "./modules/popups";
import {featuredProjectsBigSlider} from "./modules/featuredProjectsBigSlider";
import {projectPopupSlider} from "./modules/projectPopupSlider";
import {portfolioGridView} from "./modules/portfolioGridView";
import {relatedProjectsSlider} from "./modules/relatedProjectsSlider";
import {clientsOverviewSlider} from "./modules/clientsOverviewSlider";
import {projectDetailsSlider} from "./modules/projectDetailsSlider";
import {trendingSocialListSlider} from "./modules/trendingSocialListSlider";
import {portfolioProjectsSliderMobile} from "./modules/portfolioProjectsSliderMobile";
import {testimonialScrollImages} from "./modules/testimonialScrollImages";
import {forminatorButtons} from "./modules/forminatorButtons";


binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": headerActions,
        ".has-animation": animationOnScroll,
        ".hero-animation-slider": heroAnimationSlider,
        ".to-top": toTop,
        ".shared-values-slider": sharedValuesSlider,
        ".trusted-by-companies-slider": trustedByCompaniesSlider,
        ".recognition-section-slider": recognitionSectionSlider,
        ".custom-photos-gallery": customPhotosGallery,
        ".parallax": parallax,
        ".hero-video-animation": heroVideoAnimation,
        ".scroll-bottom-button": firstSectionScrollBottom,
        ".popup-opener": popups,
        ".featured-projects-big-slider": featuredProjectsBigSlider,
        ".project-popup-slider": projectPopupSlider,
        ".portfolio-grid-view-button": portfolioGridView,
        "select,.jcf-scrollable": customSelect,
        ".related-projects-slider": relatedProjectsSlider,
        ".clients-overview-slider": clientsOverviewSlider,
        ".project-details-hero-slider": projectDetailsSlider,
        ".trending-social-list-slider": trendingSocialListSlider,
        ".portfolio-listing.slider-on-mobile": portfolioProjectsSliderMobile,
        ".testimonial-scroll-images": testimonialScrollImages,
        ".forminator-button": forminatorButtons
    },
    runTests: false
});
window.initProjectPopupSlider = function () {
    projectPopupSlider();
};
window.initParallax = function () {
    parallax();
};
window.initCustomScroll = function () {
    if ($(".jcf-scrollable").length) {
        jcf.destroy(".jcf-scrollable");
        jcf.replaceAll();
    }
};


// WEBPACK FOOTER //
// ./assets/js/global.js